import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface Props {
    isError: boolean;
    hasActiveFilters: boolean;
    templateId?: string | null;
    onClearFilters: () => void;
    onCreateTemplate: () => void;
}

export const OrganizationCloseTemplatesEmptyState = ({
    isError,
    hasActiveFilters,
    templateId,
    onClearFilters,
    onCreateTemplate,
}: Props) => {
    if (isError) {
        return (
            <EmptyState
                header="Failed to load templates"
                body="Something went wrong while loading templates. Please try again."
                ctaText={undefined}
            />
        );
    }
    if (hasActiveFilters) {
        return (
            <EmptyState
                header="No templates found"
                body={
                    templateId
                        ? "This template no longer exists or isn't available in this organization."
                        : "No templates match your search or filters."
                }
                ctaText="Clear filters"
                action={onClearFilters}
            />
        );
    }
    return (
        <EmptyState
            header="No templates yet"
            body="Create a template to standardize the tasks and schedules for your services."
            ctaText="New template"
            action={onCreateTemplate}
        />
    );
};
